import '@polymer/polymer/polymer-legacy.js';
import { Polymer } from '@polymer/polymer/lib/legacy/polymer-fn.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { DefaultComputedBindings } from '../../modules/DefaultComputedBindings.js';
/* global Polymer, Firebase, k */
Polymer({
  _template: html`
    <style>
      :host {
        display: flex;
      }
      [hidden] {
        display: none !important;
      }
      .sidePhotoContainer {
        top: 0;
        margin-top: 0;
        height: 100%;
        position: relative;
        width: 200px;
        flex-grow: 1;
        cursor: default;
        z-index: 1;
      }
      .fitParent {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
      }
      .upshotClassifierContainer {
        position: absolute;
        bottom: 10px;
        left: 10px;
        width: calc(100% - 20px);
        display: flex;
        justify-content: center;
        z-index: 2;
      }
      .upshotClassifier {
        display: flex;
        justify-content: space-around;
        width: inherit;
        text-align: center;
        align-items: center;
        max-width: 420px;
        padding: 4px;
        border-radius: 4px;
        color: #bbb;
        background-color: #212121;
      }
      .upshotClassifierItem {
        display: flex;
        text-align: center;
        align-items: center;
      }
      .upshotMenuPaperInput {
        display: inline-block;
        text-align: center;
        --paper-input-container: {
          margin-top: -20px;
        };
        --paper-input-container-input-color: #bbb;
        --paper-input-container-focus-color: white;
      }
      .smallInput {
        width: 60px;
      }
      .tinyInput {
        width: 30px;
      }
      .upshotWarning {
        position: absolute;
        top: 10px;
        left: 10px;
        height: calc(100% - 20px);
        width: calc(100% - 20px);
        display: flex;
        justify-content: center;
        align-items: center;
        pointer-events: none;
      }
      .upshotWarning p {
        background-color: #212121;
        color: white;
        padding: 14px;
        border-radius: 4px;
        text-align: center;
        max-width: 280px;
      }
    </style>
    <template is="dom-if" if="{{equal(view, 'upshot')}}">
      <template is="dom-repeat" items="{{upshots}}" as="upshot">
        <div class="sidePhotoContainer">
          <katapult-photo-viewer
            class="fitParent"
            load-data=""
            zoom=""
            use-metric-units="[[useMetricUnits]]"
            name$="{{upshot.key}}"
            job-id="{{jobId}}"
            photo-id="{{upshot.key}}"
            user-group="{{userGroup}}"
            on-viewer-photo-tap="tapPhoto"
            auto-resize=""
            disabled="[[disabled]]"
            on-photo-data-loaded="photoDataLoaded"
            show-warnings
          >
            <katapult-photo-annotation
              disabled="[[disabled]]"
              can-drag
              name$="upshot_anno_{{upshot.key}}"
              use-metric-units="[[useMetricUnits]]"
              attribute-name="upshot_measurement"
              model="{{getUpshotModel()}}"
              value="{{upshot.measurement}}"
              other-attributes="{{otherAttributes}}"
              editable="{{upshot.isValid}}"
              on-drag-marker="upshotMeasurementChanged"
              job-id="[[jobId]]"
            ></katapult-photo-annotation>
          </katapult-photo-viewer>
          <div hidden$="{{upshot.isValid}}" class="upshotWarning">
            <p>The <i>'{{upshot.cameraModel}}'</i> is not supported for upshots at this time.</p>
          </div>
          <template is="dom-if" if="{{showUpshotMeasurementButtons}}">
            <div class="upshotClassifierContainer" hidden$="{{!upshot.isValid}}" on-keydown="stopPropagation">
              <div class="upshotClassifier">
                <span class="upshotClassifierItem"
                  ><span>Measuring @</span
                  ><paper-input class="upshotMenuPaperInput smallInput" value="{{upshot.objectHeight::input}}"
                    ><div slot="suffix">'</div></paper-input
                  ></span
                >
                <span class="upshotClassifierItem"
                  ><span>Camera @</span
                  ><paper-input class="upshotMenuPaperInput tinyInput" value="{{upshot.cameraHeight::input}}"
                    ><div slot="suffix">'</div></paper-input
                  ></span
                >
                <span class="upshotClassifierItem"
                  ><span style="color:white"
                    >Line: {{getDistance(upshot.key, upshot.cameraModel, upshot.image_width, upshot.image_height, upshot.rotation,
                    upshot.focal_length, upshot.measurement.pixel_selection, upshot.objectHeight, upshot.cameraHeight,
                    upshot.recalc)}}'</span
                  ></span
                >
              </div>
            </div>
          </template>
        </div>
      </template>
    </template>
  `,

  is: 'upshot-measurement',

  properties: {
    view: {
      type: String
    },
    acceptedCameraModels: {
      type: Object,
      value: function () {
        return [
          { camera_model: 'TG-5            ', sensor_size: 4.6 },
          { camera_model: 'RICOH WG-4', sensor_size: 4.6 },
          { camera_model: 'RICOH WG-4 GPS', sensor_size: 4.6 },
          { camera_model: 'RICOH WG-5', sensor_size: 4.6 },
          { camera_model: 'RICOH WG-5 GPS', sensor_size: 4.6 }
          // ,{camera_model: "Canon EOS REBEL T5i", sensor_size: 14.9}
        ];
      }
    },
    jobId: String,
    showUpshotMeasurementButtons: {
      type: Boolean,
      notify: true
    },
    totalUpshotMeasurement: {
      type: Number,
      notify: true
    },
    useMetricUnits: {
      type: Boolean,
      value: false
    },
    disabled: Boolean
  },

  behaviors: [DefaultComputedBindings],

  observers: ['getTotalUpshotMeasurement(upshotMeasurements.*)'],

  getDistance: function (key, cameraModel, image_width, image_height, rotation, focal_length, pixel_selection, objectHeight, cameraHeight) {
    var camera = this.getCamera(cameraModel);
    if (pixel_selection[0] && pixel_selection[1] && camera && camera.sensor_size) {
      if (this.upshotMeasurements == null) {
        this.upshotMeasurements = {};
      }
      if (rotation == 1 || rotation == 3) {
        [image_width, image_height] = [image_height, image_width];
      }
      var p1 = { x: pixel_selection[0].percentX * image_width, y: pixel_selection[0].percentY * image_height };
      var p2 = { x: pixel_selection[1].percentX * image_width, y: pixel_selection[1].percentY * image_height };
      var radiusPixels = Math.floor(Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)) / 100);

      var smallDim = image_height > image_width ? image_width : image_height;
      var largeDim = image_height > image_width ? image_height : image_width;
      var focalLength = focal_length;

      var sensorSize = (camera.sensor_size * (smallDim / (largeDim / 4))) / 3; // Hard coded for now.
      if (sensorSize > camera.sensor_size) sensorSize = camera.sensor_size;
      var fovRadians = 2 * Math.atan(sensorSize / 2 / focalLength);
      var fovDegrees = fovRadians * (180 / Math.PI);
      var fovFeet = (objectHeight - cameraHeight) * Math.tan(fovRadians / 2) * 2;
      var radiusFeet = (fovFeet / smallDim) * radiusPixels;
      this.set('upshotMeasurements.' + key, radiusFeet);
      return Math.round(radiusFeet * 10) / 10;
    }
    return 'N/A';
  },

  getTotalUpshotMeasurement: function () {
    if (this.upshotMeasurements != null && this.upshotMeasurements != {}) {
      var length = 0;
      for (var measurement in this.upshotMeasurements) {
        length += this.upshotMeasurements[measurement];
      }
      this.set('totalUpshotMeasurement', Math.round(length));
    } else {
      this.set('totalUpshotMeasurement', 0);
    }
  },

  getCamera: function (cameraModel) {
    for (var i = 0; i < this.acceptedCameraModels.length; i++) {
      var camera = this.acceptedCameraModels[i];
      if (camera && camera.camera_model == cameraModel) return camera;
    }
    return null;
  },

  getUpshotModel: function () {
    return { _attributes: { pixel_selection: { _color: 'rgba(255, 235, 59, 0.7)', _draw: 'line' } } };
  },

  getUpshotValue: function (measurement, isValid) {
    if (isValid) return measurement;
    else return { pixel_selection: [] };
  },

  upshotMeasurementChanged: function (e) {
    this.set('upshots.' + e.model.index + '.recalc', !this.upshots[e.model.index].recalc);
  },

  photoDataLoaded: function (e) {
    var photo = e.target.photoData;
    if (photo) {
      this.set('upshots.' + e.model.index + '.cameraModel', photo.camera_model);
      this.set('upshots.' + e.model.index + '.image_width', photo.image_width);
      this.set('upshots.' + e.model.index + '.image_height', photo.image_height);
      this.set('upshots.' + e.model.index + '.focal_length', photo.focal_length);
      for (var i = 0; i < this.acceptedCameraModels.length; i++) {
        if (this.acceptedCameraModels[i].camera_model == photo.camera_model) {
          this.set('upshots.' + e.model.index + '.isValid', true);
          break;
        }
      }
    }
  },

  tapPhoto: function (e) {
    if (this.view == 'upshot') {
      var photoId = e.currentTarget.getAttribute('name');
      var photo = e.currentTarget.photoData;
      // Make sure this is an upshot photo that was clicked.
      if (photo && photo.photofirst_data && photo.photofirst_data.upshot) {
        // var upshotKey = Object.keys(photo.photofirst_data.upshot)[0];
        // if (upshotKey && e.detail.percentX != null && e.detail.percentY != null) {
        //   var upshot = photo.photofirst_data.upshot[upshotKey];
        //   var pointIndex = (upshot.pixel_selection && upshot.pixel_selection[0]) ? "1" : "0";
        //   FirebaseWorker.ref("photoheight/jobs/" + this.jobId + "/photos/" + photoId + "/photofirst_data/upshot/" + upshotKey + "/pixel_selection/" + pointIndex).update({percentX: e.detail.percentX, percentY: e.detail.percentY}, function() {});
        // }

        var upshotIndex = null;
        // Find correct upshot record.
        for (var i = 0; i < this.upshots.length; i++) {
          if (this.upshots[i].key == photoId) {
            upshotIndex = i;
            break;
          }
        }
        // Make sure upshot exists and all dependencies are present.
        if (upshotIndex != null && e.detail && e.detail.percentX && e.detail.percentY && photo.image_width && photo.image_height) {
          // Get clicked point in px x,y.
          // var point = {x: e.detail.percentX * photo.image_width, y: e.detail.percentY * photo.image_height};
          var point = { percentX: e.detail.percentX, percentY: e.detail.percentY };
          if (!this.upshots[upshotIndex].measurement.pixel_selection[0]) {
            // upshot.p2 = point; // Didn't trigger mutation.

            // this.upshots[upshotIndex].measurement[1] = point;
            this.set('upshots.' + upshotIndex + '.measurement.pixel_selection.0', point);
            this.set('upshots.' + upshotIndex + '.recalc', !this.upshots[upshotIndex].recalc);
          } else if (!this.upshots[upshotIndex].measurement.pixel_selection[1]) {
            // upshot.p1 = point; // Didn't trigger mutation.
            this.set('upshots.' + upshotIndex + '.measurement.pixel_selection.1', point);
            this.set('upshots.' + upshotIndex + '.recalc', !this.upshots[upshotIndex].recalc);
          }
        }
      }
    }
  }
});
